/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../../../node_modules/jquery-ui-bundle');
require('./components/typeahead.bundle.min');
require('./components/stickytabs');
require('./classes/order');
require('./classes/client');
require('./classes/reports');
require('./classes/orderitems');
require('./classes/files');
require('./classes/orderstatuses');
window.InputMask = require('inputmask/dist/inputmask/inputmask.date.extensions');
// Not using VUE.

// window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));
//
// const app = new Vue({
//     el: '#app'
// });

/* Start of BOC global app code. */
$(document).ready(function () {
	$('.alert').not('.alert-important').fadeOut(4000);

	// Highlight validation errors on most pages (not orders page, handled in orders class)
	if (typeof (error_keys) != 'undefined') {
		for (i = 0; i < error_keys.length; i++) {
			$('[name="' + error_keys[i] + '"]').css('background', '#ffff99');
		}
	}
	$('#newclientalert').click(function () {
		$(this).hide();
	});
});

$('.print').click(function () {
	window.print();
});
$('.deleteitem').click(function () {
	return confirm('Are you sure you want to delete this item?');
});

/*Timeout - redirect user to login after 1 hour and 55 minutes. */

var idleTime = 0;
var abortCheck = 0;
$(document).ready(function () {
	// Increment the idle time counter every minute.
	// var idleInterval = setInterval(timerIncrement, 60000); //check once a minute
	var pathname = window.location.pathname;
	var noTimeoutPaths = ['/clients/create/selfreg', '/clients/create'];
	if ( $.inArray(pathname, noTimeoutPaths) === -1) {
		var idleInterval = setInterval(timerIncrement, 20000);
	}
});

function timerIncrement () {
	idleTime = idleTime + 1;
	if (idleTime > 120) { // 120 minutes
		// window.location.href = '/logout';
	}

	// Stop checking if logged out.
	if (abortCheck == 1) {
		return;
	}
	// Send Ajax call every minute to check for new registrations.
	$.ajax({
		method: 'GET',
		url: '/check',
	}).done(function ( msg ) {
		if (msg !== '0') {
			names = '<strong>New client(s) just registered:</strong><br>';
			$(msg).each(function (k, v) {
				names = names + '<br>' + v;
			});
			$('#newclientalert').html(names).fadeIn(1000).delay(20000).fadeOut(1000);
		}
	}).fail(function (msg) {
		if (msg.statusText == 'Unauthorized') {
			abortCheck = 1;
		}
	});
}
